<div class="FeaturesByPropertyGroupTable">    
    <table v-if="stats.length > 0" class="Table">

        <tr>
            
            <th>{{propertyDisplayTitle}}</th>
            <th class="numeric">Anzahl</th>
            
        </tr>
        
        <tr v-for="entry in stats">
          
            <td>{{entry.code}}</td>
            <td class="numeric">{{entry.sum}}</td>
            
        </tr>
    </table>
    
</div>
